import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.ops-account-page {
  color: var(--ops-text);
}

.ops-account-inner {
  display: grid;
  gap: 18px;
  padding: 22px 24px 32px;
}

.ops-account-header {
  display: flex;
  min-height: 136px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
  padding: 24px 28px;
  box-shadow: 0 20px 42px rgba(15, 23, 42, 0.08);
}

.ops-account-identity {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 18px;
}

.ops-account-large-avatar {
  display: inline-flex;
  width: 62px;
  height: 62px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(16, 24, 20, 0.14);
  border-radius: 50%;
  background: #101915;
  color: #dff5e9;
  font-size: 23px;
  font-weight: 900;
}

.ops-account-header h1 {
  margin-top: 5px;
  color: var(--ops-text);
  font-size: 30px;
  font-weight: 900;
  line-height: 1.16;
}

.ops-inline-meta {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 10px;
}

.ops-inline-meta span {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  border: 1px solid var(--ops-border);
  background: #f6f8f7;
  padding: 0 9px;
  color: var(--ops-muted);
  font-size: 11px;
  font-weight: 900;
  line-height: 1.2;
}

.ops-account-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(320px, 0.95fr);
  gap: 18px;
}

.ops-account-panel {
  min-width: 0;
  border: 1px solid var(--ops-border-strong);
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.06);
}

.ops-account-panel-head {
  display: flex;
  min-height: 78px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid var(--ops-border);
  padding: 18px 20px;
}

.ops-account-panel-head h2 {
  margin-top: 4px;
  color: var(--ops-text);
  font-size: 18px;
  font-weight: 900;
  line-height: 1.2;
}

.ops-account-panel-head > span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  border: 1px solid var(--ops-border);
  background: #f6f8f7;
  padding: 0 9px;
  color: var(--ops-muted);
  font-size: 11px;
  font-weight: 900;
}

.ops-profile-summary {
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid var(--ops-border);
  padding: 18px 20px;
}

.ops-profile-summary .ops-account-avatar {
  width: 42px;
  height: 42px;
  flex: 0 0 auto;
  font-size: 15px;
}

.ops-profile-summary strong,
.ops-profile-summary em {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-profile-summary strong {
  color: var(--ops-text);
  font-size: 14px;
  font-weight: 900;
}

.ops-profile-summary em {
  margin-top: 4px;
  color: var(--ops-muted);
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
}

.ops-form-stack {
  display: grid;
  gap: 14px;
  padding: 18px 20px 20px;
}

.ops-form-field {
  display: grid;
  gap: 7px;
}

.ops-form-field span {
  color: var(--ops-muted);
  font-size: 11px;
  font-weight: 900;
  line-height: 1.2;
}

.ops-form-field input {
  width: 100%;
  min-height: 42px;
  border: 1px solid var(--ops-border-strong);
  background: rgba(255, 255, 255, 0.94);
  padding: 0 12px;
  color: var(--ops-text);
  font-size: 13px;
  font-weight: 800;
  outline: none;
  transition: border-color 140ms ease, box-shadow 140ms ease, background 140ms ease;
}

.ops-form-field input:focus {
  border-color: #101915;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(16, 25, 21, 0.08);
}

.ops-form-field input:disabled {
  background: #eef2f0;
  color: var(--ops-muted);
}

.ops-account-actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid var(--ops-border);
  padding: 16px 20px;
}

.ops-account-actions .ops-command-button {
  min-width: 128px;
}

.ops-command-button:disabled {
  cursor: default;
  opacity: 0.58;
}

@media (max-width: 900px) {
  .ops-account-inner {
    padding: 16px 14px 24px;
  }
  .ops-account-header {
    align-items: flex-start;
    flex-direction: column;
    padding: 20px;
  }
  .ops-account-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .ops-account-header h1 {
    font-size: 24px;
  }
}`],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public session: any = {};
    public saving: boolean = false;
    public changingPassword: boolean = false;

    public passwordForm: any = {
        current_password: '',
        new_password: '',
        confirm_password: ''
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.service.auth.allow('/access');
        this.session = this.service.auth?.session || {};
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call('get');
        if (code === 200) {
            this.user = data;
        } else {
            this.user = { ...this.session };
        }
        await this.service.render();
    }

    public userInitial() {
        const name = this.user?.name || this.session?.name || '운영';
        return String(name).charAt(0);
    }

    public userDepartment() {
        return this.user?.department || this.user?.team || this.session?.department || this.session?.team || '운영 담당';
    }

    public userRole() {
        return this.user?.role || this.session?.role || this.session?.auth || '사용자';
    }

    public async updateProfile() {
        if (!this.user?.name) {
            await this.service.modal.error('이름을 입력해주세요.');
            return;
        }

        this.saving = true;
        await this.service.render();

        const { code, data } = await wiz.call('update_profile', {
            name: this.user.name,
            mobile: this.user.mobile || ''
        });

        await this.service.sleep(500);
        this.saving = false;

        if (code === 200) {
            await this.service.modal.success('프로필이 업데이트되었습니다.');
            await this.load();
        } else {
            await this.service.modal.error(data || '업데이트에 실패했습니다.');
        }
        await this.service.render();
    }

    public async changePassword() {
        const { current_password, new_password, confirm_password } = this.passwordForm;

        if (!current_password) {
            await this.service.modal.error('현재 비밀번호를 입력해주세요.');
            return;
        }
        if (!new_password) {
            await this.service.modal.error('새 비밀번호를 입력해주세요.');
            return;
        }
        if (new_password.length < 8) {
            await this.service.modal.error('새 비밀번호는 8자 이상이어야 합니다.');
            return;
        }
        if (new_password !== confirm_password) {
            await this.service.modal.error('새 비밀번호가 일치하지 않습니다.');
            return;
        }

        this.changingPassword = true;
        await this.service.render();

        const { code, data } = await wiz.call('change_password', {
            current_password: current_password,
            new_password: new_password
        });

        await this.service.sleep(500);
        this.changingPassword = false;

        if (code === 200) {
            await this.service.modal.success('비밀번호가 변경되었습니다.');
            this.passwordForm = { current_password: '', new_password: '', confirm_password: '' };
        } else {
            await this.service.modal.error(data || '비밀번호 변경에 실패했습니다.');
        }
        await this.service.render();
    }
}

export default PageMypageComponent;